// extracted by mini-css-extract-plugin
module.exports = {"prompt":"GetPhished_prompt__3z2ZA","emailForm":"GetPhished_emailForm__33Tgb","emailInput":"GetPhished_emailInput__1RMej","phishMe":"GetPhished_phishMe__nCRF3"};